import { FC } from 'react'

import { ISvgClass } from '../interface'

const WifiIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M6.35 14.35L4.25 12.2C5.28333 11.1667 6.46667 10.375 7.8 9.825C9.13333 9.275 10.5333 9 12 9C13.4667 9 14.871 9.279 16.213 9.837C17.5543 10.3957 18.7333 11.2 19.75 12.25L17.65 14.35C16.9 13.6 16.0377 13.021 15.063 12.613C14.0877 12.2043 13.0667 12 12 12C10.9333 12 9.91267 12.2043 8.938 12.613C7.96267 13.021 7.1 13.6 6.35 14.35ZM2.1 10.1L0 8C1.58333 6.38333 3.41233 5.14567 5.487 4.287C7.56233 3.429 9.73333 3 12 3C14.2667 3 16.4373 3.429 18.512 4.287C20.5873 5.14567 22.4167 6.38333 24 8L21.9 10.1C20.5833 8.78333 19.071 7.77067 17.363 7.062C15.6543 6.354 13.8667 6 12 6C10.1333 6 8.346 6.354 6.638 7.062C4.92933 7.77067 3.41667 8.78333 2.1 10.1ZM12 20L8.475 16.45C8.94167 15.9833 9.47933 15.625 10.088 15.375C10.696 15.125 11.3333 15 12 15C12.6667 15 13.3043 15.125 13.913 15.375C14.521 15.625 15.0583 15.9833 15.525 16.45L12 20Z"
        fill="inherit"
      />
    </svg>
  )
}

export default WifiIcon
